import { render } from "./BaseInfoFields.vue?vue&type=template&id=36645306&scoped=true"
import script from "./BaseInfoFields.vue?vue&type=script&lang=js"
export * from "./BaseInfoFields.vue?vue&type=script&lang=js"

import "./BaseInfoFields.vue?vue&type=style&index=0&id=36645306&scoped=true&lang=css"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36645306"]])

export default __exports__